import { setCulture } from "../EasyProjectsCommon/setCulture";

// set culture in separate module during its execution so that there is no error
// when both setCulture and a module, that uses currentCultureSettings, are imported in one file.
setCulture();
